import React, { useState } from "react";
import { Check, Images, X } from "lucide-react";

const clean = (s) => (s || "").replace(/\.(jpe?g|png|webp)$/i, "");

// Visual picker for the merchant's OWN uploaded products (data comes from /marketing-videos/status). Multi-select ≤ max.
export const MarketingProductPicker = ({ products, picked, onChange, disabled, max = 5 }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(picked);
  const chosen = products.filter((p) => picked.includes(p.id));
  const toggle = (id) => setDraft((s) => (s.includes(id) ? s.filter((x) => x !== id) : s.length < max ? [...s, id] : s));
  const start = () => { setDraft(picked); setOpen(true); };
  return (
    <div>
      <button type="button" disabled={disabled} onClick={start} data-testid="mv-open-product-picker"
        className="inline-flex items-center gap-2 text-sm font-bold px-4 py-2 rounded-full border border-[#7AB2B2] text-[#09637E] bg-white hover:bg-[#EBF4F6] transition-colors disabled:opacity-50">
        <Images className="w-4 h-4" /> منتجات من إمداد (اختياري){picked.length > 0 && <span className="bg-[#09637E] text-white rounded-full px-2 text-xs" data-testid="mv-picked-count">{picked.length}</span>}
      </button>
      {chosen.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2" data-testid="mv-picked-list">
          {chosen.map((p) => (
            <span key={p.id} className="inline-flex items-center gap-1.5 bg-[#EBF4F6] border border-[#7AB2B2] rounded-full pr-1 pl-2 py-0.5 text-xs" data-testid={`mv-picked-${p.id}`}>
              {p.image_url && <img src={p.image_url} alt="" className="w-6 h-6 rounded-full object-cover" />}
              <span className="font-bold text-[#333333]">{clean(p.name) || p.type}</span>
              {p.product_code && <span className="font-mono text-[#666666]" dir="ltr">{p.product_code}</span>}
              {!disabled && <button type="button" aria-label="إزالة" onClick={() => onChange(picked.filter((x) => x !== p.id))} data-testid={`mv-unpick-${p.id}`} className="p-0.5 rounded-full hover:bg-white"><X className="w-3 h-3" /></button>}
            </span>
          ))}
        </div>
      )}
      {open && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-end md:items-center justify-center" data-testid="mv-product-picker" onClick={() => setOpen(false)}>
          <div dir="rtl" onClick={(e) => e.stopPropagation()} className="bg-white w-full md:max-w-2xl max-h-[88vh] rounded-t-3xl md:rounded-2xl flex flex-col overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#EBF4F6]">
              <div className="font-extrabold text-[#09637E]">اختر منتجاتك <span className="text-xs font-bold text-[#666666]">({draft.length}/{max})</span></div>
              <button type="button" onClick={() => setOpen(false)} aria-label="إغلاق" data-testid="mv-picker-close" className="p-1 rounded-full hover:bg-[#EBF4F6]"><X className="w-5 h-5" /></button>
            </div>
            <div className="overflow-y-auto p-3 grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="mv-picker-grid">
              {products.map((p) => {
                const on = draft.includes(p.id);
                return (
                  <button key={p.id} type="button" onClick={() => toggle(p.id)} data-testid={`mv-product-${p.id}`} aria-pressed={on}
                    className={`relative text-right rounded-xl border-2 overflow-hidden transition-colors ${on ? "border-[#09637E] bg-[#EBF4F6]" : "border-[#E5EEF0] bg-white"}`}>
                    <div className="aspect-square bg-[#F3F6F7]">
                      {p.image_url ? <img src={p.image_url} alt={clean(p.name)} className="w-full h-full object-cover" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center text-[#999]"><Images className="w-8 h-8" /></div>}
                    </div>
                    {on && <span className="absolute top-2 left-2 w-7 h-7 rounded-full bg-[#09637E] text-white flex items-center justify-center" data-testid={`mv-product-selected-${p.id}`}><Check className="w-4 h-4" /></span>}
                    <div className="p-2">
                      <div className="text-xs font-bold text-[#333333] truncate">{clean(p.name) || p.type || "منتج"}</div>
                      <div className="text-[11px] text-[#666666] truncate">{[p.type, p.category].filter(Boolean).join(" · ")}</div>
                      <div className="text-[11px] font-mono text-[#09637E]" dir="ltr">{p.product_code || "—"}</div>
                    </div>
                  </button>
                );
              })}
            </div>
            <div className="flex gap-2 p-3 border-t border-[#EBF4F6] bg-white">
              <button type="button" onClick={() => { onChange(draft); setOpen(false); }} data-testid="mv-picker-confirm" className="flex-1 h-11 rounded-xl bg-[#09637E] text-white font-bold">تأكيد الاختيار{draft.length ? ` (${draft.length})` : ""}</button>
              <button type="button" onClick={() => setOpen(false)} data-testid="mv-picker-cancel" className="h-11 px-4 rounded-xl border border-[#7AB2B2] text-[#09637E] font-bold">إلغاء</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
